import React, { createContext, useCallback, useContext, useState } from 'react';
const NotificationContext = createContext(undefined);
let nextId = 1;
export const NotificationProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    const addToast = useCallback((type, message) => {
        const id = nextId++;
        setToasts((prev) => [...prev, { id, type, message }]);
        setTimeout(() => removeToast(id), 5000);
    }, [removeToast]);
    return (React.createElement(NotificationContext.Provider, { value: { toasts, addToast, removeToast } }, children));
};
export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};
